















import { Component, Vue, Prop } from 'vue-property-decorator'

import CustomerNotificationListItem from '@/components/CustomerNotificationListItem.vue'

import CustomerNotification from '@/models/customer-notification'

@Component({
  components: {
    CustomerNotificationListItem,
  },
})
export default class CustomerNotificationsList extends Vue {
  @Prop() dismissable!: boolean
  @Prop() notifications!: CustomerNotification[]
}
